<template>
	<v-dialog
		v-model="model"
		max-width="480"
	>
		<v-card>
			<v-card-title>
				Emissão de certificado
			</v-card-title>
			<v-card-text>
				Confirma que o Ir&#x2234; {{ certificado.irmao.nomeCompleto }} esteve presente na sessão {{ certificado.evento.tipoDaSessao.nome }} do dia {{ formatarData(certificado.evento.data) }}?
			</v-card-text>
			<v-card-actions>
				<v-btn
					text
					color="grey"
					:disabled="isPending"
					@click="emit('input', false)"
				> Ainda não </v-btn>
				<v-btn
					text
					color="error"
					class="ml-auto"
					:loading="status === 'rejeitado' && isPending"
					:disabled="isPending"
					@click="alterarStatusDoCertificado('rejeitado')"
				> Rejeitar </v-btn>
				<v-btn
					text
					color="success"
					class="ml-auto"
					:loading="status === 'aprovado' && isPending"
					:disabled="isPending"
					@click="alterarStatusDoCertificado('aprovado')"
				> Aprovar </v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script setup lang="ts">
import CertificadoService from '@/services/CertificadoService';
import { useMutation } from '@tanstack/vue-query';
import { CertificadoDetalhado, StatusDoCertificado } from '@/../common/types/certificado/Certificado'
import { computed, ref } from 'vue'
import { formatarData } from '@/../common/shareds/formatadores';
import { alert } from '@/store';

const props = defineProps<{
  value: boolean
  certificado: CertificadoDetalhado
}>()

const emit = defineEmits<{
  (e: 'input', value: boolean): void
  (e: 'change', value: CertificadoDetalhado): void
}>()

const model = computed<boolean>({
  get: () => props.value,
  set: (v) => emit('input', v)
})

const status = ref<StatusDoCertificado>()

function alterarStatusDoCertificado(novoStatus: StatusDoCertificado) {
	status.value = novoStatus
	mutate(novoStatus)
}

const { mutate, isPending } = useMutation({
    mutationFn: (status: StatusDoCertificado) =>
        CertificadoService.patch(props.certificado._id, { status }),
    onSuccess(certificado) {
        emit('change', certificado)
    },
	onError(error) {
		alert.setError(error)
	},
})

</script>